import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-not-found-error',
  imports: [NgClass],
  templateUrl: './not-found-error.html',
  styleUrl: './not-found-error.css',
})
export class NotFoundError {
  @Input() className: string = '';
}
